export default __webpack_public_path__ + "static/media/sem_parametros.f0ce87f1.svg";